import React from 'react';
import { Link } from 'react-router-dom';
import { Text } from '../../../components';
import { NewRMCard } from '../NewRMCard';
import { CardTrendPercentage } from '../CardTrendPercentage/CardTrendPercentage';
import { RightOutlined } from '@ant-design/icons';
import { isDiscoveryEnabled } from '../../../layout/sidebar/hooks/useNavigation';
import { useInventorySummaryData } from '../../SummaryWrapper/useInventorySummaryData';
import { calculatePercentage, formatPercent } from '../../SummaryWrapper/inventorySummaryHelpers';
import { ROUTE_CONFIG, DISCOVERY_ROUTE_CONFIG } from '../../../constants/routes';

import './SourcesCard.scss';

export const SourcesCard = ({ sources, handleCardClick }) => {
    const { inventoryTotals } = useInventorySummaryData();
    const sourcesPercentage = formatPercent(calculatePercentage(sources, inventoryTotals?.totalInventory));

    return (
        <NewRMCard className="sources-card" showMoreIcon={false}>
            <header>
                <div className="header-left">
                    <Text size="large" color="secondary">
                        Sources
                    </Text>
                    {isDiscoveryEnabled() && (
                        <Link to={DISCOVERY_ROUTE_CONFIG.inventory.path}>
                            <Text color="primaryBlue" bold>
                                Add More
                                <RightOutlined />
                            </Text>
                        </Link>
                    )}
                </div>
            </header>
            <div className="sources-card-content" onClick={() => handleCardClick(ROUTE_CONFIG.sources.path)}>
                <Text size="extraLarge" xxlBold color="primaryBlue">
                    {sources}
                </Text>
            </div>
        </NewRMCard>
    );
};
